import React from 'react'
import styled, { useTheme } from 'styled-components/native'

import { Images } from 'APP/Themes'
import Config from 'APP/Config'
import I18n from 'APP/I18n'
import { isEmbeddedEnvironment } from 'APP/BrownfieldBridge/utils'
import Typography from 'APP/Converse/Typography'
import Logo from 'APP/Components/Logo'

const Container = styled.View`
  flex-shrink: 1;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: ${({ theme }) => theme.metrics.baseMargin / 2}px;
  padding: ${({ theme }) => theme.metrics.baseMargin}px;
`

const DialogueBranding = () => {
  const theme = useTheme()

  if (!Config.DIALOGUE_BRANDING_ENABLED || isEmbeddedEnvironment()) {
    return null
  }

  return (
    <Container testID="DIALOGUE_BRANDING_VIEW">
      <Typography testID="DIALOGUE_BRANDING_TEXT">{I18n.t('DialogueBranding.tagline')}</Typography>
      <Logo
        height={theme.metrics.icon.small}
        source={Images.logoBrand}
        alt={`${I18n.t('DialogueBranding.tagline')} Dialogue`}
        testID="DIALOGUE_BRANDING_IMAGE"
      />
    </Container>
  )
}

export default DialogueBranding
